import React from 'react';
import { useSelector } from 'react-redux'

import { EventEmitter } from 'events';
import struct from 'observ-struct';

import ObservApi from '../lib/observable-api.js';
import ImporterController from '../importer/components/Controller';
import EncoderStore from '../metadata/components/DomainStore.js';
import LocationStore from '../metadata/components/DomainStore.js';
import CategoryStore from '../metadata/components/DomainStore.js';


const ImportRoute = (api, socket) => {
    var socketBus = new EventEmitter();
    socket.encoders(function onEvent (ev) {
        socketBus.emit(ev.action.type, ev);
    });


    var encoderApi = ObservApi(api.encoders);
    var encoderStore = EncoderStore('encoders', encoderApi.bus, socketBus);

    var locationApi = ObservApi(api.locations);
    var locationStore = LocationStore('locations', locationApi.bus, socketBus);

    var categoryApi = ObservApi(api.categories);
    var categoryStore = CategoryStore('categories', categoryApi.bus, socketBus);

    var state = struct({
        encoders: encoderStore.state,
        locations: locationStore.state,
        categories: categoryStore.state
    });

    var actions = {
        createCategory: api.categories.add,
        createEvent: api.events.add,
        get: function () {
            encoderApi.actions.get({});
            locationApi.actions.get({});
            categoryApi.actions.get({});
        }
    };

    const clientID = useSelector(state => state.data.client.clientID)
    return () => {
        return <ImporterController
            store={state}
            actions={actions}
            clientID={clientID}
        />;
    }
};

export default ImportRoute
